import {connect} from "react-redux";
import Email from "./../component/Email";
import {changeEmail} from "../actions";
import {getFilledEmail, issetErrorForField, isCusotomerLoggedIn} from "../reducers";

const mapStateToProps = state => {
    return {
        value: getFilledEmail(state),
        isError: issetErrorForField('email', state),
        isDisabled: isCusotomerLoggedIn(state),
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChange: (value) => {
            dispatch(changeEmail(value))
        },
    }
}

const EmailContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Email)

export default EmailContainer